import styled from '@emotion/styled';

export const LabelTitle = styled.h1`
  font-family: Arial, "Trebuchet MS", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  text-transform: uppercase;
  text-align: left;
  padding: 5px 15px;
  margin-bottom: 15px;
  color: #f0e7e7;
  color: rgb(91 56 36);
  text-align: start;
  background-color: rgba(240, 231, 231, 0.75);
  border-radius: 15px;
  padding: 5px 15px;
  @media screen and (min-width: 480px) {
    font-size: 22px;
  }
  @media screen and (min-width: 768px) {
    font-size: 24px;
  }
  @media screen and (min-width: 1200px) {
    font-size: 26px;
  }
`;
